import { EApiKey, PUBLIC_SEARCH_PREFIX } from '@/publicSearch/constants';
import { useEffect, useState } from 'react';
import Parser from 'rss-parser';
import useSWR from 'swr';

type TFeedItemMediaContent = {
  height: string;
  width: string;
  isDefault: string;
  medium: string;
  type: string;
  url: string;
};

const url = `${PUBLIC_SEARCH_PREFIX}/newsfeed`;

const parser = new Parser({
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
  customFields: {
    item: ['media:content'],
  },
});

export function useNewsFeed() {
  const [debouncedIsLoading, setDebouncedIsLoading] = useState(true);

  const queryFeed = useSWR(EApiKey.GET_NEWS_FEED, async () => {
    const feed = await parser.parseURL(url);
    return feed.items.map((i) => ({
      ...i,
      mediaContent: i['media:content'].$ as TFeedItemMediaContent,
    }));
  });

  // hides loading artefacts
  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (!queryFeed.isLoading && !queryFeed.isValidating) {
      timeout = setTimeout(() => setDebouncedIsLoading(false), 500);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [queryFeed.isLoading, queryFeed.isValidating]);

  return {
    ...queryFeed,
    isLoading: debouncedIsLoading,
  };
}
